import { object, string, number, date, array } from 'yup';

export default object().shape({
  name: string().required(),
  applyTo: string().required(),
  adjustments: array().required().min(1),
  constraints: array(),
  filters: array(),
  grantLimit: number(),
  priority: number(),
  activeAt: date().nullable(),
  expiresAt: date().nullable(),
});
